import apiFetch from '../apiFetch'

export default function (token, faqId) {
  return apiFetch({ endPoint: `Faq/${faqId}/Recover`, method: 'PUT', token: token })
}
